import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import topic from 'dojo/topic';
import RequestManager from 'more/RequestManager';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import template from './templates/Sidebar.html?raw';
import domStyle from 'dojo/dom-style';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
// template-instantiated child widgets (data-dojo-type) — bare side-effect imports so the loader preloads them.
import "./SubstituteForm";
import "./LangSelect";

// window- and DOM-heavy widget: alias both to any (window props not on lib.dom, and dom-construct
// create()-results are used as parents). Behaviour unchanged (w === window).
const w: any = window;
const domConstruct: any = domConstructTyped;

class Sidebar extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;

    templateString: any = template;

    isOpened = false;
    sidebarWidth: any = null;

    genericDialog: any = null;

    sidebarLinks: any = [];
    RedirectToHomeAction: any = null;

    langSelectVisible = true;

    // pinbutton -------------------------start
    _isSidebarPinned = false;
    _isPinningChange = false;

    _onClick_PinSidebar(): void {
        this.pinSidebar(!this._isSidebarPinned);
    }

    pinSidebar(bDoPin: any): void {
        if (bDoPin === false) {

        } else {
            bDoPin = true;
        }

        if (this._isSidebarPinned != bDoPin) {
            this._isPinningChange = true;
        }
        this._isSidebarPinned = bDoPin;

        if (this._isSidebarPinned == false) {
            domClass.remove(this.sidebarPinButton, "pinned");
            this._openSidebar();
        } else {
            domClass.add(this.sidebarPinButton, "pinned");

            this._openSidebar();
        }
    }

    _onContentNodeClick(): void {

        if (this._isSidebarPinned === false) {

            this._closeSidebar();
        }


    }

    _onSessionChange(): void {

        if (w.sessionInfo?.sessionData != null) {
            // todo: sidebar muss request machen um die links zu bekommen...
            this.loadLinks();
        } else {
            //this._initLinks();
        }
    }

    loadLinks(): void {
        var manager = new RequestManager();

        var jsonData = "{}";

        manager.post(
            w.appRoot + "Navigation/GetSidebarLinks",
            {
                "jsonData": jsonData
            },
            lang.hitch(this, this._onLoadLinksResponse),
            lang.hitch(this, this._onLoadLinksError));
    }

    _onLoadLinksResponse(response: any): void {
        //console.debug("Sidebarlinks loaded", response);

        this._initLinks(response.sidebarLinks);
    }

    _onLoadLinksError(error: any): void {
        console.error("Sidebarlinks loading error", error.Message);
    }

    // Pinbutton -----------------------------end
    _setLangSelectVisibleAttr(value: any): void {
        this.langSelectVisible = value;

        if (this.langSelectVisible == true) {
            domStyle.set(this.langSelect.domNode, "display", "");
        } else {
            domStyle.set(this.langSelect.domNode, "display", "none");
        }
    }

    _setupSubscriptions(): void {
        this._topics.push(topic.subscribe("/Session/Loading", lang.hitch(this, this._onSessionLoading))); //
        this._topics.push(topic.subscribe("/Session/Open", lang.hitch(this, this._onCheckForExistingSessionResult))); //
        this._topics.push(topic.subscribe("/Session/NewSession", lang.hitch(this, this._onSessionChange))); //
        this._topics.push(topic.subscribe("/Session/CheckForExistingSession", lang.hitch(this, this._onCheckForExistingSessionResult)));
        this._topics.push(topic.subscribe("/Session/Close", lang.hitch(this, this._onCheckForExistingSessionResult)));
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any)

        this.sidebarLinks = w.pageLinks;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        //console.debug("sidebar postcreate");
        topic.subscribe("layout/contentNode_click", lang.hitch(this, "_onContentNodeClick"));
        w.lytSidebar = this;
        w.sidebar = this;
        domAttr.set(this.linkUserLogin, "href", w.appRoot + "home/login");

        this._setMarginToTopBar();



    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        this.sidebarWidth = w.getComputedStyle(this.domNode).width;

        this.checkForExistingSession();

        if (w.showLanguageSelector === false || w.showLanguageSelector === true) {
            if (!w.showLanguageSelector) {
                this._setLangSelectVisibleAttr(false);
            }
        }

        if (w.showSidebarPin === false || w.showSidebarPin === true) {
            domClass.toggle(this.sidebarPinButton, "w3-hide", w.showSidebarPin != true);
            if (w.pinSidebar === true || w.pinSidebar === false) {

                this._isSidebarPinned = w.pinSidebar;
            }
        }

        this._isSidebarPinned = this._isSidebarPinned && w.innerWidth > 800;


        //setInterval(lang.hitch(this, "checkForExistingSession"), 900000 * 2 - 60000); // 15 min x 2 - 1 Minute = 29 Minuten. Das Netscaler-Timeout ist auf 30 Minuten gesetzt. Läuft daher nie ab solange das Tab geöffnet ist
    }


    _onSessionLoading(isLoading: any): void {
        // Ladeanimation bei Login
        var topUserInfoNode = document.getElementById("top_login_info");

        if (topUserInfoNode) {
            domClass.toggle(topUserInfoNode, "loading egoAnimated_fadingHourglassOverlay", isLoading === true);
            domClass.toggle(topUserInfoNode, "w3-hide", isLoading !== true && !w.sessionInfo?.sessionData);
        }

        domClass.toggle(this.userInfoContainer, "loading egoAnimated_fadingHourglassOverlay", isLoading === true);
        domClass.toggle(this.userInfoContainer, "w3-hide", isLoading !== true && !w.sessionInfo?.sessionData);
    }

    checkForExistingSession(): void {

        var data = w.sessionInfo?.sessionData;

        //console.debug("Sidebar checkForExistingSession", data);

        if (data) {

        } else {
            //// Ladeanimation bei Login
            //var topUserInfoNode = document.getElementById("top_login_info");
            //if (topUserInfoNode) {
            //    domClass.add(topUserInfoNode, "loading");
            //}

        }

        this._onCheckForExistingSessionResult(data);
    }

    _onCheckForExistingSessionResult(response: any): void {
        //console.debug("Sidebar existing session", response);
        var isSession = w.sessionInfo.isSessionOpen();
        if (isSession) {
            let strData = localStorage.getItem("ego_Sidebar");
            let data = null;
            try {
                if (strData) {
                    data = JSON.parse(strData);
                }
            } catch (ex) {

            }

            if (data) {

                if (data.sidebarPinned === true || data.sidebarPinned === false) {
                    //this._isSidebarPinned = data.sidebarPinned;

                    this.pinSidebar(data.sidebarPinned && w.innerWidth > 800);
                }
                if (!this._isSidebarPinned) {
                    this.toggleOpen(false);
                }
                else if ((data.sidebarOpen === true || data.sidebarOpen === false) && this._isSidebarPinned === true) {
                    this.toggleOpen(data.sidebarOpen);
                }


            }
            else {
                this._closeSidebar();
            }
        } else {
            this.toggleOpen(false, false);
        }

        this._initLinks();
        this._updateStyles();
    }

    _onCheckForExistingSessionError(error: any): void {

        console.error("_onCheckForExistingSessionError", error);
    }

    getSubEntryByName(name: any): any {
        let currentSelect = this.getSelectedLink();
        if (!currentSelect) return null;

        for (let entry of currentSelect.subEntries) {
            if (entry.name == name) {
                return entry;
            }
        }

        return null;
    }

    addEntryToCurrentNavigation(descriptor: any): any {
        let currentSelect = this.getSelectedLink();
        if (currentSelect && descriptor) {
            let existingEntry = this.getSubEntryByName(descriptor.name);
            if (existingEntry) return;

            let subEntry: any = {
                name: descriptor.name
            };

            subEntry.node = domConstruct.create("div", { className: "subEntry flex_row_center nowrap" }, currentSelect.element);

            let subLink = domConstruct.create("a", { innerHTML: descriptor.label, className: "mds-hover-dark" }, subEntry.node);
            subEntry.labelNode = subLink;

            if (descriptor.enableClosing) {
                let closeBtn = domConstruct.create("button", {
                    className: "mds-button-base hoverDark",
                    id: "closeBtn",
                    innerHTML: this.createFontawesomeIcon("fas fa-times").outerHTML
                }, subEntry.node);

                on(closeBtn, "click", lang.hitch(this, this._onRequestCloseSubEntry, subEntry));
            }

            //let iconclass = "fas fa-angle-right";
            let iconclass = null;// "fas fa-angle-right";
            if (descriptor.iconclass) {
                iconclass = descriptor.iconclass;
            }
            if (iconclass) {
                let icon = this.createFontawesomeIcon(iconclass);
                domConstruct.place(icon, subEntry.labelNode, "first");
            }

            if (descriptor.color) {
                subEntry.node.style.setProperty("--linkColor", descriptor.color);
            }

            on(subEntry.node, "click", lang.hitch(this, this._onClick_SubEntry, descriptor.name, descriptor.callback));

            currentSelect.subEntries.push(subEntry);

            return subEntry;
        }

        return null;
    }

    _onRequestCloseSubEntry(subEntry: any): void {
        this.emit("requestClose", subEntry.name);
    }

    removeSubentryByName(targetName: any): any {
        let currentSelect = this.getSelectedLink();
        if (!currentSelect) {
            return false;
        }
        for (let i = 0; i < currentSelect.subEntries.length; i++) {
            let entry = currentSelect.subEntries[i];
            if (entry.name == targetName) {
                domConstruct.destroy(entry.node);
                currentSelect.subEntries.splice(i, 1);
                return true;
            }
        }
        return true;
    }

    renameSubentryLabel(targetName: any, newName: any): any {
        let subEntry = this.getSubEntryByName(targetName);
        if (subEntry) {
            domAttr.set(subEntry.labelNode, "innerHTML", newName);
        }
        return true;
    }

    activateSubentryByName(targetName: any): void {
        let currentSelect = this.getSelectedLink();
        if (!currentSelect) {
            return;
        }
        for (let entry of currentSelect.subEntries) {
            if (entry.name == targetName) {
                domClass.add(entry.node, "selected");
            }
            else {
                domClass.remove(entry.node, "selected");
            }
        }
    }

    _onClick_SubEntry(name: any, callback?: any, evt?: any): void {
        this.activateSubentryByName(name);
        if (typeof (callback) == "function") {
            callback();
        }
    }

    _initLinks(newLinks?: any): void { // und wo ist initRechts?? HAHAHAHA

        if (!w.sessionInfo) {
            return;
        }

        var roles = w.sessionInfo.getRoles();
        var isSession = w.sessionInfo.isSessionOpen();

        if (this.sidebarLinks) {
            for (var i = 0; i < this.sidebarLinks.length; i++) {
                if (this.sidebarLinks[i].element != null && typeof (this.sidebarLinks[i].element) != "undefined") {
                    domConstruct.destroy(this.sidebarLinks[i].element);
                    this.sidebarLinks[i].element = null;
                }
            }
        }

        this.sidebarLinks = [];

        if (typeof (newLinks) != "undefined") { // neue Links kommen -> alte destroyen

            this.sidebarLinks = newLinks;
        }

        //domConstruct.empty(this.linkContainer);

        //console.debug("sidebar initLinks", isSession, roles, this.sidebarLinks);

        var i = 0;
        //this.sidebarLinks = window.pageLinks;
        var maxind = this.sidebarLinks.length - 1;

        while (i <= maxind) {
            var displayLink = false;
            var link = this.sidebarLinks[i];

            link.subEntries = [];

            var bHasNode = link.element != null && typeof (link.element) != "undefined";

            //console.debug("sidebar displaylink", link, isSession, roles);

            // braucht keine Rolle?
            if (link.role == "" || link.role == null || typeof (link.role) == "undefined") {
                displayLink = true;
            }
            // wenn doch: Rolle vorhanden?
            else {
                var j = 0;

                while (j < roles.length) {
                    if (roles[j] == "ADMIN" || roles[j] == link.role) {
                        displayLink = true;
                        break;
                    }
                    j++;
                }
            }

            // nur anzeigen wenn keine Session offen?
            if (isSession != false && link.noSessionOnly === true) {
                displayLink = false;
            }

            // nur anzeigen wenn Session offen?
            if (isSession == false && link.SessionOnly === true) {
                displayLink = false;
            }

            //console.debug("sidebar initLink " + link.text, "session?", isSession, "node?", bHasNode, "Display?", displayLink, link.element);

            // Linknode schon vorhanden und muss weg?
            if (bHasNode === true && displayLink != true) {

                domConstruct.destroy(link.element);
                link.element = null;

            } else if (displayLink === true && bHasNode != true) {

                var label = link.label;
                if (typeof (link.label) == "undefined") {
                    label = link.text;
                    link.label = label;
                }
                let linkContainer = domConstruct.create("div", {
                    className: "linkItem"
                }, this.linkContainer)
                var linknode = domConstruct.create("a", {
                    className: "w3-bar-item mds-button-base mds-hover-dark w3-padding",
                    innerHTML: "",
                }, linkContainer);

                var linkLabel = domConstruct.create("span", {
                    innerHTML: label
                }, linknode);

                let iconclass = "fas fa-caret-right";
                if (link.iconclass) {
                    iconclass = link.iconclass;
                }

                if (iconclass) {
                    var colorclass = "";
                    var colorStyle = {};
                    //if (link.colorclass) {
                    //    colorclass = link.colorclass;
                    //} else if (link.colorBG) {
                    //    colorStyle = { "backgroundColor": link.colorBG };
                    //}
                    var linkIcon = domConstruct.create("i", {
                        className: iconclass + " " + colorclass + " sidebarLinkIcon",
                        style: colorStyle
                    }, linknode, "first");

                    linkIcon.style.setProperty("font-size", "inherit", "important");
                    // die hintergrundfarbe des Icons umschreiben zur Textfarbe
                    let css = w.getComputedStyle(linkIcon);
                    //console.debug("computed linkstyle", css);
                    //if (css.backgroundColor) {
                    //    //domStyle.set(linkIcon, "color", css.backgroundColor);
                    //    linknode.style.setProperty("--selectedColor", css.backgroundColor);
                    //    domStyle.set(linkIcon, "backgroundColor", "unset");
                    //    //domStyle.set(linkIcon, "textShadow", "1px 1px var(--dark)");
                    //}

                }

                if (typeof (link.target) != "undefined") {
                    link.url = w.appRoot + link.target;
                }

                domAttr.set(linknode, "href", link.url);

                link.element = linkContainer;
            }

            this.sidebarLinks[i] = link;

            i++;
        }

        let selectedLink = this.getSelectedLink();
        if (selectedLink) {
            domClass.add(selectedLink.element, "selected");
        }

        //console.debug("sidebar links after init", this.sidebarLinks);

        topic.publish("sidebar/linksCreated", this.sidebarLinks);
    }

    isLinkSelected(link: any): any {
        return location.pathname.toLowerCase() == link.url.toLowerCase();
    }

    getSelectedLink(): any {
        for (let link of this.sidebarLinks) {
            if (this.isLinkSelected(link)) {
                return link;
            }
        }

        return null;
    }

    getSelectedSectionTitle(): any {
        let link = this.getSelectedLink();
        if (link) {
            return link.label;
        }

        return null;
    }

    toggleOpen(targetValue?: any, saveToStorage?: any): void {
        let lytSidebar = this;

        if (targetValue !== true && targetValue !== false) {
            targetValue = !this.isOpened;
        }

        let mainContent: any = document.getElementById("mainContent");

        if (targetValue == true) {
            domStyle.set(this.mainSidebar, "display", "");

            document.getElementById("menu_bars").style.display = "none";
            document.getElementById("menu_cross").style.display = "inline";

            //domClass.toggle(this.domNode, "w3-sidebar", !this._isSidebarPinned);

            if (this._isSidebarPinned) {
                document.getElementById("darkenOverlay").style.display = "none";
                if (mainContent && (this.isOpened != targetValue || this._isPinningChange)) {
                    let width = this.domNode.getBoundingClientRect().width;
                    let currentPadding = w.getComputedStyle(mainContent).paddingLeft;
                    this._previousPadding = currentPadding;

                    domClass.add(mainContent, "egoAnimatedPadding");
                    domStyle.set(mainContent, "paddingLeft", "calc(" + width + "px + " + currentPadding);
                    this._isPinningChange = false;
                }
            } else {
                if (mainContent) {
                    domClass.add(mainContent, "egoAnimatedPadding");
                    mainContent = domStyle.set(mainContent, "paddingLeft", this._previousPadding);
                }

                document.getElementById("darkenOverlay").style.display = "block";
            }

            document.body.style.setProperty("--sidebarWidth", this.sidebarWidth);
            topic.publish("sidebar/opened", {
                sidebarWidth: this.sidebarWidth, // string mit "px" am ende
            }); topic.publish("layout/navBar_opening", {
                sidebarWidth: this.sidebarWidth, // string mit "px" am ende
            });
        }
        else {
            domStyle.set(this.mainSidebar, "display", "none");
            document.getElementById("menu_cross").style.display = "none";
            document.getElementById("menu_bars").style.display = "inline";
            document.getElementById("darkenOverlay").style.display = "none";

            if (mainContent) {
                mainContent = domStyle.set(mainContent, "paddingLeft", this._previousPadding);
            }

            topic.publish("sidebar/closed");
            topic.publish("layout/navBar_closing");
        }

        this.isOpened = targetValue;


        setTimeout(lang.hitch(this, this._removeAnimationFromMainContent), 410);

        if (saveToStorage !== false) {
            let saveData = { "sidebarPinned": this._isSidebarPinned, "sidebarOpen": this.isOpened };
            localStorage.setItem("ego_Sidebar", JSON.stringify(saveData));
        }

        //console.debug("sidebar toggleopen", targetValue, this.isOpened);
    }

    _previousPadding: any = null;
    _removeAnimationFromMainContent(): void {
        let mainContent: any = document.getElementById("mainContent");

        domClass.remove(mainContent, "egoAnimatedPadding");

        if (this._isSidebarPinned != true && this._previousPadding) {
            domStyle.set(mainContent, "paddingLeft", null);
            this._previousPadding = null;
        }
    }

    _updateStyles(): void {

        if (!w.sessionInfo) {
            return;
        }

        var isSession = w.sessionInfo.isSessionOpen();
        var userName = w.sessionInfo.getUserName();
        var userDisplay = w.sessionInfo.getUserDisplayName();
        var sessionData = w.sessionInfo.sessionData;
        var employeeId = w.sessionInfo.getCurrentEmployeeId();

        var actualUserName = w.sessionInfo.getUserName(true);
        var actualUserDisplay = w.sessionInfo.getUserDisplayName(true);
        var actualEmployeeId = w.sessionInfo.getCurrentEmployeeId(true);
        var isSubstitute = w.sessionInfo.isSubstitutionActive();

        var userNameNode = document.getElementById("top_Username");
        var substContainer = document.getElementById("top_SubstutionContainer");
        var substNameNode = document.getElementById("top_Substutionname");
        var topUserInfoNode = document.getElementById("top_login_info");
        var bodyNode = document.getElementById("body");

        this.setProfilePic(null);

        if (topUserInfoNode != null) {
            domClass.replace(topUserInfoNode, "w3-hide", "");
        }

        if (userNameNode != null) {
            domAttr.set(userNameNode, "innerHTML", "");
        }

        if (substContainer != null) {
            domClass.add(substContainer, "w3-hide");
        }

        if (bodyNode != null) {
            domClass.remove(bodyNode, "striped_bg");
        }

        if (isSession === true) {

            domClass.replace(topUserInfoNode, "", "w3-hide loading");

            domAttr.set(this.usertext, "innerHTML", actualUserName);

            w.sessionInfo.getProfilepicData(lang.hitch(this, this.setProfilePic));

            if (actualUserDisplay != actualUserName) {

                domAttr.set(this.userDisplayText, "innerHTML", actualUserDisplay);
            }

            domClass.remove(this.userInfoContainer, "w3-hide");
            //domClass.remove(this.substituteContainer, "w3-hide");

            if (userNameNode != null) {
                domAttr.set(userNameNode, "innerHTML", "<b>{1}</b>".format(this.translations["Sidebar__UserdisplayPrefix"], actualUserDisplay));
            }

            // special auf der layout.cshtml ... buuh! schiach!
            if (isSubstitute === true) {
                if (substContainer != null && substNameNode != null) {
                    domAttr.set(substNameNode, "innerHTML", "{0}&nbsp;<b>{1}</b>".format(this.translations["SubstituteForm__CurrentSubstituteLabel"], userDisplay));
                    domClass.remove(substContainer, "w3-hide");
                }

                if (bodyNode != null) {
                    domClass.add(bodyNode, "subsitutionActive");
                }

            }


        } else {
            domAttr.set(this.usertext, "innerHTML", "");
            domAttr.set(this.userDisplayText, "innerHTML", "");
            domClass.add(this.userInfoContainer, "w3-hide");
            domClass.add(this.substituteContainer, "w3-hide");
        }
    }

    setProfilePic(data: any): void {

        //if (data) {
        //    console.debug("sidebar setprofilpic", data.checksum);
        //}

        var topUserIcon = document.getElementById("top_login_avatar_placeholder");

        if (topUserIcon) {
            domConstruct.empty(topUserIcon);
        }

        if (this.userPic) {
            domClass.add(this.userPic, "w3-hide");
            domAttr.set(this.userPic, "src", "");
        }

        //console.debug("setProfilePic", data, topUserIcon);

        if (data) {
            if (topUserIcon && data.base64) {
                let picOverlay = domConstruct.create("img", {
                    "src": "data:image/jpeg;base64," + data.base64,
                    "className": "profilePic round"
                }, topUserIcon);
            }

            if (this.userPic && data.base64) {
                domAttr.set(this.userPic, "src", "data: image/jpeg; base64, " + data.base64);
                domClass.remove(this.userPic, "w3-hide");
            }
        }
    }

    _setMarginToTopBar(): void {
        let topBar = document.getElementById("topBar_layout");
        if (topBar) {
            let height = w.getComputedStyle(topBar).height;
            document.body.style.setProperty("--marginTopbar", height);
            //    let mainContent = document.getElementById("mainContent");

            //    if (mainContent) {
            //        mainContent.style.setProperty("--marginTopbar", height);
            //    }
        }
    }

    _openSidebar(): void {
        this.toggleOpen(true);
    }

    _closeSidebar(): void {
        this.toggleOpen(false);

    }

    _onClick_Sidebar(evt: any): void {
        evt.stopPropagation();
    }

    _onClickUserInfoContainer(evt: any): void {
        //window.location.href = window.appRoot + "/home/login";
    }

}
Sidebar.prototype.declaredClass = 'more.Sidebar';

export default mdsWidget(Sidebar);
